'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import PropTypes from 'prop-types';
import UISection from '../section/UISection';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIFormActions(_ref) {
  let {
      children,
      className
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const classes = classNames(className, 'private-form-actions');
  return /*#__PURE__*/_jsx(UISection, Object.assign({}, other, {
    className: classes,
    children: children
  }));
}
UIFormActions.propTypes = {
  children: PropTypes.node.isRequired
};
UIFormActions.displayName = 'UIFormActions';